import React from "react";
import {Switch, Redirect, BrowserRouter} from "react-router-dom";
import {PrivateRoute, PublicRoute} from "./common/routers";
import {Minimal as MinimalLayout} from "./common/components";
import {OnboardingStep1 as RegisterView,
        OnboardingSteps as ConfirmationView,
        Terms as TermsView,
        EndProcess as EndProcessView,
        NotFound as NotFoundView,
        ValidateRegister,
} from "./views";
import fkz_background from "./assets/images/login-background.jpg"
import fkz_background_term from "./assets/images/terms-background.jpg"

export const AppRouter = () => {

 const basename = process.env.REACT_APP_BASENAME || null;

 return (
    <BrowserRouter basename={'/account-onboarding'} >
        <Switch>
            <Redirect exact from="/" to="/register-account" />
            <PublicRoute
                component={RegisterView}
                exact
                layout={MinimalLayout}
                image={fkz_background}
                path="/register-account"
            />
            <PublicRoute
                component={EndProcessView}
                exact
                layout={MinimalLayout}
                image={fkz_background}
                path="/register-success"
            />
            <PublicRoute
                component={ValidateRegister}
                exact
                layout={MinimalLayout}
                image={fkz_background}
                path="/check-account"            />
            <PublicRoute
                component={TermsView}
                exact
                layout={MinimalLayout}
                image={fkz_background_term}
                path="/conditions-and-terms"
            />
            <PublicRoute
                component={NotFoundView}
                exact
                layout={MinimalLayout}
                path="/not-found"
            />
            <PrivateRoute
                component={ConfirmationView}
                exact
                layout={MinimalLayout}
                image={fkz_background}
                path="/stage2"
            />
            <Redirect to="/register-account" />
        </Switch>
    </BrowserRouter>
 )
}
